import { splitProps, type Component, type JSX } from 'solid-js';
import * as css from './Button.css';

interface ButtonProps extends Omit<JSX.ButtonHTMLAttributes<HTMLButtonElement>, 'class'> {
  variant?: keyof typeof css.variants;
  size?: keyof typeof css.sizes;
  iconOnly?: boolean;
  class?: string;
}

/**
 * Single Button component for all click affordances. Variants are
 * style-only — semantics are `<button type="button">` unless callers
 * pass `type="submit"`.
 */
export const Button: Component<ButtonProps> = (raw) => {
  const [local, rest] = splitProps(raw, ['variant', 'size', 'iconOnly', 'class', 'children', 'type']);
  const variant = local.variant ?? 'secondary';
  const size = local.size ?? 'md';
  const classes = [
    css.buttonBase,
    css.variants[variant],
    css.sizes[size],
    local.iconOnly ? css.iconOnly : '',
    local.class ?? '',
  ].filter(Boolean).join(' ');
  return (
    <button {...rest} type={local.type ?? 'button'} class={classes}>
      {local.children}
    </button>
  );
};
